import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { Client } from 'src/providers/client/client';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

import { Loading } from 'src/shared/components/loading/loading';
import { ActivatedRoute } from '@angular/router';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { ContactConciergePage } from '../contact-concierge/contact-concierge';
import { JobIssuePage } from '../job-issue/job-issue';
import { JobIssueDetailPage } from '../job-issue/job-issue-detail/job-issue-detail';
import { Schedule } from 'src/providers/schedule/schedule';
import { Util } from 'src/shared/util/util';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { WindowService } from 'src/shared/providers/window.service';

@Component({
    templateUrl: 'get-help.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class GetHelpPage implements OnInit {

  loaded: boolean;
  showDeveloper: boolean;
  showIntegration: boolean;
  cantGoBack: boolean;
  isRightSideContent = true;
  dialogParams: any;
  cleaningId: number;

  constructor(
    private navCtrl: CustomNavController,
    private client: Client,
    private route: ActivatedRoute,
    private storage: TidyStorage,
    private rightSidePanelService: RightSidePanelService,
    private util: Util,
    private onboardingProvider: OnboardingProvider,
    private schedule: Schedule,
    private windowService: WindowService
  ) {}

  @Loading('', true)
  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.rightSidePanelService.setDialogPageTitle('Get Help');
    if (this.isRightSideContent) {
      this.dialogParams = await this.storage.retrieve('dialog-params');
      this.cleaningId = this.dialogParams?.cleaningId;
    }
    this.loaded = false;
    this.cantGoBack = this.route.snapshot.data.cantGoBack;
    const showIntegration = localStorage.getItem('isRentalClient');
    this.showIntegration = showIntegration === 'true';
    const isDeveloperClient = localStorage.getItem('isDeveloperClient');
    this.showDeveloper = isDeveloperClient === 'true';
    this.loaded = true;
  }

  goToContactConcierge(title: string, type: string) {
    const params = {
      title,
      type
    }
    this.rightSidePanelService.navigateTo('contact-concierge', params, ContactConciergePage);
  }

  @Loading('', true)
  async jobIssue() {
    this.loaded = false;

    // If cleaningId is provided, skip job selection and go directly to issue detail
    if (this.cleaningId) {
      const job = await this.schedule.getJobDetail(this.cleaningId);
      const jobStatus = job.job.status;
      const isPrivateJob = job.job.is_private;

      const hasHomekeeperJobs = job.homekeeper_jobs?.length > 0 && job.homekeeper_jobs[0]?.id;
      if (job.booking.bookable_service.key.includes('turnover') || jobStatus === 'Cancelled by you' || !hasHomekeeperJobs) {
        const params = {
          title: 'Job Issue',
          type: 'support.job_issue',
          metadata: {
            suptype: jobStatus === 'Cancelled by you' ? 'client_cancelled' : '2_pro_job',
            job,
            job_id: job.job.id,
            job_datetime: job.job.start_datetime
          }
        };
        this.rightSidePanelService.navigateTo('contact-concierge', params, ContactConciergePage);
      } else {
        const params = {
          job,
          jobStatus,
          isPrivate: isPrivateJob
        };
        this.rightSidePanelService.navigateTo('job-issue-detail', params, JobIssueDetailPage);
      }
      return;
    }

    // Original flow when no cleaningId is provided
    const pastJobsResponse = await this.client.getJobHistory();
    let hasPastJobs = false;
    pastJobsResponse.map((job) => {
      if (job?.service && job?.start_datetime_local) {
        hasPastJobs = true;
      }
    });
    if (hasPastJobs) {
      if (pastJobsResponse.length > 5) {
        pastJobsResponse.length = 5;
      }
      const params = {
        pastJobsResponse
      }
      this.rightSidePanelService.navigateTo('job-issue', params, JobIssuePage);
    } else {
      return this.goToContactConcierge('Job Issue', 'support.job_issue');
    }
  }

  async billingIssue() {
    const hasProperties = await this.onboardingProvider.checkIfHasProperties();
    if (!hasProperties) {
      return this.util.showError('Please add a property to your account before contacting concierge about billing.', 10000);
    }
    this.util.showSuccess(`Please tap \“Need help?\” on the billing item you have questions on, and we typically help within 4 business hours.`, 10000);
    this.rightSidePanelService.navigateTo('billing-history', {});
  }

  conciergeTask() {
    this.goToContactConcierge('Concierge Action', 'support.concierge_task');
  }

  howToUseTidy() {
    const message = 'I have a question about TIDY: ';
    this.openChatWithMessage(message);
  }

  otherQuestion() {
    const message = 'I have a question: ';
    this.openChatWithMessage(message);
  }

  private openChatWithMessage(message: string) {
    if (this.windowService.isDesktopRes) {
      this.rightSidePanelService.emitSendMessageAction('prefill', message);
      this.rightSidePanelService.closeRightSidePanel();
    } else {
      localStorage.setItem('chatPrefillMessage', message);
      this.navCtrl.navigateRoot('properties');
    }
  }
}
